import React from "react";
import {Asset, Link} from "../../../plugins/gatsby-plugin-atollon";
import parse from "html-react-parser";
import {RightArrow} from "../icons";
import AnimationButton from "../structured-text/blocks/animation-button";
import { EdlynLogo, BoneLogo, WoodsLogo, GreenWheatLogo } from "../icons";

const RecipeCard = (props) => {
    let theme
    switch (props.brand) {
        case "edlyn":
            theme = 'Edlyn'
            break
        case "bone":
            theme = 'Bone Roaster'
            break
        case "greenwheat":
            theme = 'Greenwheat'
            break
        case "woods":
            theme = 'Woods'
            break
        default:
            theme = null
    }

    return (
        <div className='card card--recipe'>
            <div className='card--recipe__image'>
                {(props.featureImage || props.thumbnail) && <Asset asset={props.thumbnail ? props.thumbnail : props.featureImage}/>}
                <span className='icon'>
                    {
                        (() => {
                            switch (props.brand) {
                                case 'woods':
                                    return <WoodsLogo/>;
                                case 'bone':
                                    return <BoneLogo/>;
                                case 'greenwheat':
                                    return <GreenWheatLogo/>;
                                default:
                                    return <EdlynLogo/>;
                            }
                        })()
                    }
                </span>
            </div>
            <div className='card--recipe__tag'>
                {props.brand && <span className={props.brand}>{theme}</span>}
            </div>
            {props.title && <h4>{parse(props.title)}</h4>}
            {props.permalink &&
                <AnimationButton className='btn btn--animation' to={props.permalink}><RightArrow color='#19419E'/></AnimationButton>
            }
        </div>
    )
}

export default RecipeCard